/* VESPERA — theme scripts (no dependencies) */
(function () {
  'use strict';
  var V = window.VESPERA || {};
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- Money ---------- */
  function money(cents) {
    cents = Math.round(Number(cents) || 0);
    var fmt = V.moneyFormat || '{{amount_with_comma_separator}} zł';
    function f(n, d, ts, ds) {
      var s = (n / 100).toFixed(d).split('.');
      s[0] = s[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return s[1] ? s[0] + ds + s[1] : s[0];
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      switch (k) {
        case 'amount': return f(cents, 2, ',', '.');
        case 'amount_no_decimals': return f(cents, 0, ',', '.');
        case 'amount_with_comma_separator': return f(cents, 2, ' ', ',');
        case 'amount_no_decimals_with_comma_separator': return f(cents, 0, ' ', ',');
        case 'amount_with_space_separator': return f(cents, 2, ' ', ',');
        case 'amount_with_apostrophe_separator': return f(cents, 2, "'", '.');
        default: return f(cents, 2, ' ', ',');
      }
    }).replace(/<[^>]*>/g, '');
  }

  /* ---------- Header scroll state ---------- */
  var header = $('[data-header]');
  function onScroll() {
    if (header) header.classList.toggle('is-scrolled', window.scrollY > 20);
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Reveal on scroll ---------- */
  var revealEls = $$('[data-reveal]');
  if ('IntersectionObserver' in window && !reduce) {
    // stagger siblings
    revealEls.forEach(function (el) {
      var sibs = $$(':scope > [data-reveal]', el.parentElement);
      var i = sibs.indexOf(el);
      if (i > 0) el.style.setProperty('--d', (i * 0.08) + 's');
    });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    revealEls.forEach(function (el) { io.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- Smooth anchor scroll ---------- */
  $$('[data-scroll]').forEach(function (a) {
    a.addEventListener('click', function (e) {
      var t = $(a.getAttribute('href'));
      if (!t) return;
      e.preventDefault();
      t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    });
  });

  /* ---------- Starfield canvas ---------- */
  $$('[data-stars]').forEach(function (cv) {
    var ctx = cv.getContext('2d'), stars = [], w, h, dpr = Math.min(window.devicePixelRatio || 1, 2), raf, visible = true;
    function size() {
      var r = cv.getBoundingClientRect();
      w = r.width; h = r.height;
      cv.width = w * dpr; cv.height = h * dpr;
      ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
      var n = Math.round((w * h) / 5200);
      stars = [];
      for (var i = 0; i < n; i++) {
        stars.push({ x: Math.random() * w, y: Math.random() * h, r: Math.random() * 1.3 + 0.2, a: Math.random(), s: Math.random() * 0.015 + 0.003, vy: Math.random() * 0.06 + 0.01 });
      }
    }
    function draw() {
      ctx.clearRect(0, 0, w, h);
      for (var i = 0; i < stars.length; i++) {
        var s = stars[i];
        s.a += s.s; s.y -= s.vy;
        if (s.y < -2) s.y = h + 2;
        var o = 0.35 + Math.abs(Math.sin(s.a)) * 0.65;
        ctx.beginPath();
        ctx.arc(s.x, s.y, s.r, 0, 6.283);
        ctx.fillStyle = 'rgba(255,255,255,' + o.toFixed(2) + ')';
        ctx.fill();
      }
      if (!reduce && visible) raf = requestAnimationFrame(draw);
    }
    size(); draw();
    window.addEventListener('resize', function () { size(); if (reduce) draw(); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        visible = es[0].isIntersecting;
        cancelAnimationFrame(raf);
        if (visible && !reduce) draw();
      }).observe(cv);
    }
  });

  /* ---------- Gallery ---------- */
  var gallery = $('[data-gallery]');
  var galleryGo = function () {};
  if (gallery) {
    var slides = $$('.v-gallery__slide', gallery);
    var thumbsWrap = $('[data-gallery-thumbs]', gallery);
    var idx = 0, timer;
    slides.forEach(function (sl, i) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'v-thumb' + (i === 0 ? ' is-active' : '');
      b.setAttribute('aria-label', 'Zdjęcie ' + (i + 1));
      var m = sl.querySelector('.v-media');
      if (m) b.appendChild(m.cloneNode(true));
      b.addEventListener('click', function () { go(i); stop(); });
      thumbsWrap.appendChild(b);
    });
    var thumbs = $$('.v-thumb', thumbsWrap);
    function go(i) {
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-active', k === idx); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === idx); });
      var t = thumbs[idx];
      if (t) thumbsWrap.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
    }
    function stop() { clearInterval(timer); }
    galleryGo = go;
    $('[data-gallery-prev]', gallery).addEventListener('click', function () { go(idx - 1); stop(); });
    $('[data-gallery-next]', gallery).addEventListener('click', function () { go(idx + 1); stop(); });
    // swipe
    var sx = null, stage = $('[data-gallery-stage]', gallery);
    stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener('touchend', function (e) {
      if (sx === null) return;
      var dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) { go(idx + (dx < 0 ? 1 : -1)); stop(); }
      sx = null;
    });
    if (!reduce && slides.length > 1) timer = setInterval(function () { go(idx + 1); }, 5000);
  }

  /* ---------- Product form ---------- */
  var form = $('[data-product-form]');
  if (form) {
    var atc = $('[data-atc]', form);
    var atcPrice = $('[data-atc-price]', form);

    function currentVariant() {
      return form.querySelector('input[name="variant"]:checked') || form.querySelector('input[name="variant"]');
    }
    function currentBundle() {
      return form.querySelector('input[name="bundle"]:checked');
    }
    function update() {
      var v = currentVariant(); if (!v) return;
      var price = +v.dataset.price || 0;
      var compare = +v.dataset.compare || 0;
      if (compare <= price) compare = 0;
      var save = compare > price ? Math.round((compare - price) / compare * 100) : 0;
      var setText = function (sel, t) { var el = $(sel); if (el) el.textContent = t; };
      setText('[data-price-now]', money(price));
      setText('[data-price-was]', money(compare));
      setText('[data-price-save]', '−' + save + '%');
      setText('[data-sticky-price]', money(price));
      if (v.dataset.title) setText('[data-variant-label]', v.dataset.title);

      $$('input[name="bundle"]', form).forEach(function (b) {
        var q = +b.value, off = +b.dataset.off || 0;
        var lab = b.closest('.v-bundle');
        var p = $('[data-bundle-price]', lab), w = $('[data-bundle-was]', lab);
        if (p) p.textContent = money((+b.dataset.unitPrice || price) * q);
        if (w) w.textContent = money(price * q);
      });
      var b = currentBundle();
      if (b && atcPrice) {
        atcPrice.textContent = money((+b.dataset.unitPrice || price) * (+b.value));
      }
      if (v.dataset.image) {
        // jump gallery to variant image if present
        var slides = $$('.v-gallery__slide img');
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].src && slides[i].src.split('?')[0] === v.dataset.image.split('?')[0]) { galleryGo(i); break; }
        }
      }
    }
    form.addEventListener('change', update);
    update();

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var v = currentVariant();
      if (!v || !v.value) return;
      var qty = +(currentBundle() ? currentBundle().value : 1);
      atc.classList.add('is-loading');
      fetch(V.cartAdd, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: +v.value, quantity: qty }] })
      }).then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Błąd'); });
        return r.json();
      }).then(function () {
        atc.classList.remove('is-loading');
        atc.classList.add('is-added');
        var label = $('[data-atc-label]', atc), prev = label.textContent;
        label.textContent = 'Dodano ✓';
        setTimeout(function () { atc.classList.remove('is-added'); label.textContent = prev; }, 1800);
        openDrawer();
      }).catch(function (err) {
        atc.classList.remove('is-loading');
        alertInline(err.message);
      });
    });

    function alertInline(msg) {
      var p = form.querySelector('.v-form__err');
      if (!p) { p = document.createElement('p'); p.className = 'v-form__err v-stock'; p.setAttribute('role', 'alert'); atc.after(p); }
      p.textContent = msg;
    }

    /* Sticky ATC */
    var sticky = $('[data-sticky]');
    if (sticky && 'IntersectionObserver' in window) {
      var stickyBtn = $('[data-sticky-atc]', sticky);
      new IntersectionObserver(function (es) {
        var show = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(atc);
      stickyBtn.addEventListener('click', function () {
        $('#kup').scrollIntoView({ behavior: reduce ? 'auto' : 'smooth' });
        setTimeout(function () { atc.focus({ preventScroll: true }); }, 600);
      });
    }

  }

  /* ---------- Cart drawer ---------- */
  var drawer = $('[data-drawer]');
  var lastFocus = null;
  function openDrawer() {
    if (!drawer) { window.location.href = V.cartUrl; return; }
    lastFocus = document.activeElement;
    refreshCart().then(function () {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      document.body.classList.add('is-locked');
      var c = $('.v-drawer__head [data-drawer-close]', drawer); if (c) c.focus();
    });
  }
  function closeDrawer() {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  $$('[data-cart-open]').forEach(function (a) {
    a.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  });
  if (drawer) {
    $$('[data-drawer-close]', drawer).forEach(function (b) { b.addEventListener('click', closeDrawer); });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function renderCart(cart) {
    var count = cart.item_count;
    $$('[data-cart-count]').forEach(function (el) { el.textContent = count; });
    var cb = $('.v-cartbtn'); if (cb) { cb.classList.remove('is-bump'); void cb.offsetWidth; cb.classList.add('is-bump'); }
    if (!drawer) return;
    var wrap = $('[data-drawer-items]', drawer);
    if (!cart.items.length) {
      wrap.innerHTML = '<p class="v-drawer__empty">Koszyk jest pusty.</p>';
    } else {
      wrap.innerHTML = cart.items.map(function (it) {
        var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="v-line__v">' + esc(it.variant_title) + '</div>' : '';
        var was = it.original_line_price > it.final_line_price ? '<s>' + money(it.original_line_price) + '</s>' : '';
        return '<div class="v-line">' +
          (img ? '<img src="' + esc(img) + '" alt="">' : '<span></span>') +
          '<div><div class="v-line__t">' + esc(it.product_title) + '</div>' + variant +
          '<div class="v-qty"><button type="button" aria-label="Mniej" data-qty="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '">−</button>' +
          '<span>' + it.quantity + '</span>' +
          '<button type="button" aria-label="Więcej" data-qty="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '">+</button></div></div>' +
          '<div class="v-line__p">' + money(it.final_line_price) + was + '</div></div>';
      }).join('');
    }
    $('[data-drawer-total]', drawer).textContent = money(cart.total_price);
  }

  function refreshCart() {
    return fetch(V.cartGet, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () {});
  }

  if (drawer) {
    drawer.addEventListener('click', function (e) {
      var b = e.target.closest('[data-qty]');
      if (!b) return;
      fetch(V.cartChange, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: b.dataset.qty, quantity: Math.max(0, +b.dataset.q) })
      }).then(function (r) { return r.json(); }).then(renderCart);
    });
  }


  /* ---------- Mobile menu ---------- */
  var menu = $('[data-menu]'), menuBtn = $('[data-menu-open]');
  function setMenu(open) {
    if (!menu) return;
    menu.classList.toggle('is-open', open);
    menu.setAttribute('aria-hidden', open ? 'false' : 'true');
    if (menuBtn) menuBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.body.classList.toggle('is-locked', open);
    if (open) { var f = $('.v-menu__head [data-menu-close]', menu); if (f) f.focus(); } else if (menuBtn) menuBtn.focus({ preventScroll: true });
  }
  if (menuBtn) menuBtn.addEventListener('click', function () { setMenu(true); });
  $$('[data-menu-close]').forEach(function (b) { b.addEventListener('click', function () { setMenu(false); }); });
  if (menu) menu.addEventListener('keydown', function (e) { if (e.key === 'Escape') setMenu(false); });

  /* ---------- Product in action demo ---------- */
  $$('[data-room]').forEach(function (room) {
    var section = room.closest('section');
    var tabs = $$('[data-scene]', section);
    var auto = null, i = 0;
    function set(scene) {
      room.setAttribute('data-scene-current', scene);
      var nm = $('[data-scene-name]', room);
      tabs.forEach(function (t) {
        var on = t.dataset.scene === scene;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        if (on && nm) nm.textContent = t.textContent.trim();
      });
    }
    tabs.forEach(function (t, k) {
      t.addEventListener('click', function () { clearInterval(auto); set(t.dataset.scene); });
    });
    var lights = $('[data-lights]', section);
    if (lights) lights.addEventListener('change', function () { room.classList.toggle('is-lit', lights.checked); });
    if (!reduce && 'IntersectionObserver' in window) {
      var started = false;
      new IntersectionObserver(function (es) {
        if (es[0].isIntersecting && !started) {
          started = true;
          auto = setInterval(function () { i = (i + 1) % tabs.length; set(tabs[i].dataset.scene); }, 3500);
        }
      }, { threshold: .4 }).observe(room);
    }
  });

  /* ---------- FAQ: one open at a time + smooth height ---------- */
  $$('.v-faq, .v-acc').forEach(function (faq) {
    var items = $$('details', faq); var single = faq.classList.contains('v-faq');
    items.forEach(function (d) {
      var sum = $('summary', d), body = $('.v-q__a', d);
      sum.addEventListener('click', function (e) {
        if (reduce) return;
        e.preventDefault();
        if (d.open) {
          var h = body.offsetHeight;
          body.animate([{ height: h + 'px', opacity: 1 }, { height: '0px', opacity: 0 }], { duration: 380, easing: 'cubic-bezier(.22,1,.36,1)' }).onfinish = function () { d.open = false; };
        } else {
          if (single) items.forEach(function (o) { if (o !== d && o.open) o.open = false; });
          d.open = true;
          var h2 = body.offsetHeight;
          body.animate([{ height: '0px', opacity: 0 }, { height: h2 + 'px', opacity: 1 }], { duration: 480, easing: 'cubic-bezier(.22,1,.36,1)' });
        }
      });
    });
  });
})();


